import { createStyles, Theme } from '@nelnet/unifi-components-react';

const platformnavstyles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      listStyle: 'none',
      margin: `1rem ${spacing(3)}px 1rem auto`,

      '& a': {
        color: 'inherit',
        display: 'inline-block',
      },

      '& svg': {
        width: '24px',
        height: '24px',
        fill: 'currentColor',
      },

      '& li + li': {
        marginLeft: '1.25rem',
      },
    },
    currPlatform: {
      position: 'relative',
      '&::after': {
        content: '""',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 0,
        bottom: '-.6rem',
        height: 0,
        position: 'absolute',
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderBottom: '6px solid currentColor',
      },
    },
  });

export default platformnavstyles;
